<template>
    <div>
        <forms-vue
            v-bind:title="title"
            :form="form"
            v-bind:submit_url="submit_url"
            v-bind:redirect_submit_url="redirect_submit_url"
            v-bind:redirect_submit_url_params="redirect_submit_url_params"
            v-bind:edit_get_url="edit_get_url"
            v-bind:watch="watch"
            v-bind:submit_in_url="submit_in_url"
            v-model="modelValores"
        />

    </div>
</template>
<script type="text/javascript">
export default {
    data() {
        return {
            modelValores: {},
            perfil: "administrador",
            formularioValues: {},
            title: "Nueva Etapa",
            submit_url: this.$route.fullPath + "/save",
            redirect_submit_url: "EtapasRegistro",
            redirect_submit_url_params: {},
            edit_get_url: "",
            submit_in_url: false,
            items: [],
            accesos: [],
            watch: [
                {
                    watch: "value.tipo_nc_codi",
                    route: this.$root.UrlBase("selects/init"),
                    select: ["0", "0", "0", "15"],
                    model: "FichasEtapaNCActivo",
                    attr: "tipo_nc_codi",
                },
            ],
            form: [
                [
                    {
                        col: "12",
                        title: "Datos Generales	",
                        footer: {},
                        attrs: [
                            [
                                {
                                    pretty_name: "Tipo:	",
                                    name: "tipo_nc_codi",
                                    desc: "",
                                    type: "select",
                                    cols: "12",
                                    options: [],
                                    extra: {
                                        required: true,
                                    },
                                    required: true,
                                },
                                {
                                    pretty_name: "Descripción",
                                    name: "descripcion",
                                    desc: "",
                                    type: "text",
                                    cols: "6",
                                    extra: {
                                        required: true,
                                    },
                                },
                                {
                                    pretty_name: "Orden dentro de la Etapa:	",
                                    name: "orden_nro",
                                    desc: "",
                                    type: "number",
                                    cols: "6",
                                    extra: {
                                        required: true,
                                    },
                                },
                                {
                                    pretty_name: "Observaciones",
                                    name: "obser",
                                    desc: "",
                                    type: "textarea",
                                    cols: "12",
                                },
                                {
                                    pretty_name:
                                        "Días por defecto para Resolución:	",
                                    name: "dias_resoluc_defecto",
                                    desc: "",
                                    type: "number",
                                    cols: "6",
                                },
                                {
                                    pretty_name:
                                        "Horas por defecto para Resolución:	",
                                    name: "horas_resoluc_defecto",
                                    desc: "",
                                    type: "number",
                                    cols: "6",
                                },
                                {
                                    pretty_name: "Cantidad de Responsables:	",
                                    name: "marca_canti_respon",
                                    desc: "",
                                    type: "select",
                                    cols: "6",
                                    options: [
                                        {
                                            label: "Unico",
                                            code: "U",
                                        },
                                        { label: "Multiple", code: "M" },
                                    ],
                                    extra: {
                                        required: true,
                                    },
                                },
                                {
                                    pretty_name:
                                        "Permite cambio de Responsable:	",
                                    name: "marca_usa_cambio_respon",
                                    desc: "select",
                                    type: "select",
                                    cols: "6",
                                    options: [
                                        {
                                            label: "Si",
                                            code: "S",
                                        },
                                        { label: "No", code: "N" },
                                    ],
                                    extra: {
                                        required: true,
                                    },
                                    required: true,
                                },
                                {
                                    pretty_name:
                                        "Lista abierta de Destinatarios:	",
                                    name: "respon_lista_abierta",
                                    desc: "select",
                                    type: "select",
                                    cols: "6",
                                    options: [
                                        {
                                            label: "Si",
                                            code: "S",
                                        },
                                        { label: "No", code: "N" },
                                    ],
                                    extra: {
                                        required: true,
                                    },
                                },
                                {
                                    pretty_name: "Obliga ingreso de observ.:	",
                                    name: "marca_obser_obliga",
                                    desc: "",
                                    type: "select",
                                    cols: "6",
                                    options: [
                                        { label: "Si", code: "S" },
                                        { label: "No", code: "N" },
                                    ],
                                    extra: {
                                        required: true,
                                    },
                                },
                                {
                                    pretty_name: "Ubicación de observ.:	",
                                    name: "ubica_observa",
                                    desc: "",
                                    type: "select",
                                    cols: "6",
                                    options: [
                                        {
                                            label: "Arriba (Primer dato a solicitar)",
                                            code: "A",
                                        },
                                        {
                                            label: "Abajo (Ultimo dato a solicitar)",
                                            code: "B",
                                        },
                                        {
                                            label: "NO UTILIZA OBSERVACIONES",
                                            code: "N",
                                        },
                                    ],
                                    extra: {
                                        required: true,
                                    },
                                },
                                {
                                    pretty_name: "Estado: ",
                                    name: "estado",
                                    desc: "",
                                    type: "select",
                                    cols: "6",
                                    options: [
                                        { label: "Activo", code: "A" },
                                        { label: "Dado de baja", code: "B" },
                                    ],
                                    extra: {
                                        required: true,
                                    },
                                },
                                {
                                    pretty_name: "Responsables por defecto: ",
                                    name: "responsables_default",
                                    desc: "",
                                    type: "select",
                                    cols: "6",
                                    options: [],
                                    extra: {
                                        required: true,
                                        multiple: true,
                                    },
                                },
                                {
                                    pretty_name: "Observadores por defecto: ",
                                    name: "observadores_default",
                                    desc: "",
                                    type: "select",
                                    cols: "6",
                                    options: [],
                                    extra: {
                                        required: true,
                                        multiple: true,
                                    },
                                },
                                {
                                    pretty_name: "Es multi Tarea/Etapa: ",
                                    name: "multi_etapa",
                                    desc: "",
                                    type: "select",
                                    cols: "6",
                                    options: [
                                        { label: "Si", code: 1 },
                                        { label: "No", code: 0 },
                                    ],
                                    extra: {
                                        required: true,
                                    },
                                },
                                {
                                    pretty_name: "Etapa multiple: ",
                                    name: "multi_etapa_contenido_codi",
                                    desc: "",
                                    type: "select",
                                    cols: "6",
                                    options: [],
                                    extra: {
                                        required: true,
                                    },
                                },
                            ],
                        ],
                        footer: {
                            buttons: [
                                {
                                    type: "button",
                                    text: "Cancelar",
                                    class: "btn btn-danger pull-left",
                                    route: "EtapasRegistro",
                                },
                                {
                                    type: "submit",
                                    text: "Guardar",
                                    class: "btn btn-success pull-right",
                                    route: "EtapasRegistro",
                                },
                            ],
                        },
                    },
                ],
            ],
        };
    },
    computed: {},
    methods: {},
    mounted() {},
    created() {
        const data = {
            selects: {
                TipoNC: { categoria_nc: "RE", estado: "A" },
                User: {},
            },
        };
        this.$root
            .Consulta(
                this.$root.UrlBase("selects/init"),
                data,
                "post",
                false,
                false,
                false,
                "",
                false
            )
            .then((response) => {
                this.form[0][0].attrs[0][12].options = response.User;
                this.form[0][0].attrs[0][13].options = response.User;
                this.form[0][0].attrs[0][0].options = response.TipoNC;
            });
    },
};
</script>
